import './index.scss'
import React, { useEffect, useState, useCallback } from 'react';
import UnitDetails from './UnitDetails';
import SideDrawerMenu from '../../reusableComponents/sideDrawerMenu/sideDrawerMenu';
import moment from 'moment';
import HuntDetails from './huntDetails'
import { connect } from 'react-redux'
import LockIcon from '../../../../../asset/lock.png'
import Locktext from './locktext';
import { huntPlannerActiveOtions } from '../../../../action/huntplanner-selected-options';
import { fetchGetHuntUnitList } from '../../../../action/huntPlanner-api-actions';
import { fetchGetHuntList } from '../../../../action/huntPlanner-api-actions';
import { removeLayers } from '../../huntplanner-layer-render/renderlayerFunction';
import { fetchGetFilterValues } from '../../../../action/huntPlanner-api-actions';
import { multiTileHuntLayers } from "../../huntplanner-layer-render/renderlayerFunction";
import { fetchGetUnitDetails } from '../../../../action/huntPlanner-unitdetails-actions';
import { huntPlannerRightMenuBarOpen, huntPlannerRightMenuBarClose } from '../../../../action/huntplanner-menu-bar';
import { startLoading, stopLoading } from '../../../../action/huntPlanner-load-spinner-action';
import Loader from '../../reusableComponents/loader/Loader';

const HuntItemsData = (props) => {
  const [loadItemDetails, setLoadItemDetails] = useState(false)
  const [selectedItem, setSelectedItem] = useState()
  const [onHuntClick, setOnHuntClick] = useState(false)

  // useEffect(() => {
  //   if (props.huntPlannerUnitRightMenuBar.expanded && props.huntPlannerUnitRightMenuBar.mapData) {
  //     // Only call closeUnit if we're not already collapsed
  //     closeUnit()
  //   }
  // }, [props.huntPlannerUnitRightMenuBar.expanded, props.huntPlannerUnitRightMenuBar.mapData])


  let {
    huntData,
    selectedTab,
    huntPlannerUnits,
    huntPlannerHunts,
    selectedFilterOptions,
    unitDetailsResponse,
    huntPlannerFilterOptions
  } = props;

  const onItemClick = () => {
    setLoadItemDetails((prev) => !prev);  // Toggle state properly
    props.huntPlannerRightMenuBarOpen({ mapData: false, expanded: true });
    // Ensure setSelectedItem is updating correctly
    setSelectedItem((prev) => prev || {});  // Update based on previous value if needed
  };

  let huntPoints = huntPlannerHunts && huntData.minPoints
    ? JSON.parse(huntData.minPoints)
    : null;

  if (huntPoints) { }

  let renderLayerUnit = (reqUnit) => {
    let payload = {
      ...props.huntPlannerSelectedOtions,
      unitName: huntData?.geoName?.trim() || huntData?.unitName?.trim(),
    }
    let unitName = huntData?.geoName?.trim() || huntData?.unitName?.trim()
    fetchFilterMenuValue(payload)
      .then((response) => {
        let layerId = response?.layerId
        let layerPayload = {
          unitName: huntData?.geoName?.trim() || huntData?.unitName?.trim(),
        }
        let layerRenderingApi = `layer/RenderSingleHuntUnit/${layerId}`
        const params = new URLSearchParams(layerPayload).toString();
        if (layerPayload.unitName) {
          // removeLayers(props.huntplannerMapReference)
          multiTileHuntLayers('object',
            layerPayload,
            { mapInstance: props.huntplannerMapReference, filters: [] },
            true,
            layerRenderingApi,
            params,
            response,
            () => {
            })
        }
        else {
          console.log('layer dont have unit data')
        }
      })
    props.huntPlannerActiveOtions(payload)
    // if (unitName) {
    //   fetchUnitDetails(payload)
    // }
  }

  let closeUnit = () => {
    console.log('helo close')
    props.huntPlannerRightMenuBarClose();
    setLoadItemDetails(!loadItemDetails);
    let payload = {
      ...props.huntPlannerSelectedOtions,
    }
    let layerRenderingApi = 'Layer/RenderHuntUnits'
    // const params = new URLSearchParams(payload).toString();

    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
        delete payload[key];
      }
    });

    const params = new URLSearchParams(payload).toString();
    multiTileHuntLayers('object',
      payload, { mapInstance: props.huntplannerMapReference, filters: [] }, true, layerRenderingApi, params, props.huntPlannerFilterOptions, () => {
      })
    // })
  }

  let fetchUnitDetails = (payload) => {
    if (payload.unitName) {
      props.fetchGetUnitDetails(payload)
        ?.then((res) => {
        })
        .catch((err) => console.log(err))
    }
  }

  let fetchFilterMenuValue = (payloadData) => {
    return new Promise((resolve, reject) => {
      let payload = {
        StateAbbreviation: payloadData.StateAbbreviation,
        Species: payloadData.Species,
        HuntTypeKey: payloadData.HuntTypeKey,
      };

      props.fetchGetFilterValues(payload)
        ?.then((res) => {
          resolve(res);
        })
        ?.catch((error) => {
          console.error("API Error:", error);
          reject(error);
        });
    });
  }

  return (
    <>
      {huntPlannerUnits && huntData &&
        <div className="unit-card" onClick={() => onItemClick(huntData)}>
          <h3>Unit: {huntData?.unitName ?? '-'}</h3>

          <h6>{huntData?.huntCount ? `${huntData.huntCount} ${huntData.huntCount > 1 ? 'Hunts' : 'Hunt'}` : '-'}</h6>

          <div className="unit-stats">
            <div className="stat">
              <Locktext
                LockIcon={LockIcon}
                text={huntData?.unitScore ?? 0}
                showText={huntPlannerFilterOptions?.huntResearch}
              >
                <span className={`value ${huntData?.unitScore <= 33 ? 'red' : huntData?.unitScore <= 66 ? 'yellow' : 'green'}`}>
                  {huntData?.unitScore ?? 0}
                </span>/100
              </Locktext>
              <div className="progress">
                <div
                  className={`progress-bar ${huntData?.unitScore <= 33 ? 'red' : huntData?.unitScore <= 66 ? 'yellow' : 'green'}`}
                  style={{ width: `${huntData?.unitScore ?? 0}%` }}
                ></div>
              </div>
              <p className="label">Unit Score</p>
            </div>

            <div className="stat">
              <Locktext
                LockIcon={LockIcon}
                text={(huntData?.trophy ?? 0) + '"'}
                showText={huntPlannerFilterOptions?.huntResearch}
              />

              <div className="progress">
                <div
                  className={`progress-bar ${huntData?.trophy <= 33 ? 'red' : huntData?.trophy <= 66 ? 'yellow' : 'green'}`}
                  style={{ width: `${huntData?.trophy ?? 0}%` }}
                ></div>
              </div>
              <p className="label">Trophy</p>
            </div>

            <div className="stat">
              <p className="value font-style-roboto" style={{ height: 20 }}>{huntData?.publicLand + '%' ?? '-'}</p>
              <div className="progress">
                <div
                  className={`progress-bar ${huntData?.publicLand <= 33 ? 'red' : huntData?.publicLand <= 66 ? 'yellow' : 'green'}`}
                  style={{ width: `${huntData?.publicLand ?? 0}%` }}
                ></div>
              </div>
              <p className="label">Public Land</p>
            </div>
          </div>
        </div>
      }

      {onHuntClick && <Loader position={'absolute'} left={'42%'} width={'30px'}></Loader>}

      {huntPlannerHunts && huntData &&
        <div className="unit-card" onClick={() => onItemClick()}>
          <h3>Weapon: {huntData.weapon}</h3>

          <div className='margin-bottom-05em margin-top-025em'>
            <p className='p-text' style={{ color: '#1d1d1d' }}>Gender :<span className={`${huntData?.sex == 'female' ? 'red' : 'orange'}`}> {huntData.sex} </span></p>
            <p className='p-text'>Unit : {huntData.unitName}</p>
            <p className='p-text'>
              {moment(huntData.startDate).format('MMM D') + ' - ' + moment(huntData.endDate).format('MMM D')}
            </p>
          </div>

          <div className="unit-stats">
            <div className="stat">
              <Locktext
                LockIcon={LockIcon}
                text={(huntPoints && huntPoints.point ? huntPoints.point : '-')}
                showText={huntPlannerFilterOptions?.huntResearch}
              />
              <div className="progress">
                <div
                  className={`progress-bar ${huntPlannerFilterOptions?.huntResearch ? (huntPoints && huntPoints.point) && 'yellow' : ''} `}
                  style={{ width: `${huntPlannerFilterOptions?.huntResearch ? (huntPoints && huntPoints.point) : '0'}` }}
                >{ }-</div>
              </div>
              <p className="label">Min Pts</p>
            </div>

            <div className="stat">
              <Locktext LockIcon={LockIcon} text={(huntPoints?.odds != null ? huntPoints.odds.toFixed(1) + '%' : '-')} showText={huntPlannerFilterOptions?.huntResearch}></Locktext>

              <div className="progress">
                <div
                  className={`progress-bar ${huntPlannerFilterOptions?.huntResearch ? 'yellow' : ''} `}
                  style={{ width: `${huntPlannerFilterOptions?.huntResearch ? (huntPoints?.odds ? huntPoints.odds + '%' : 0 + '%') : '0%'}` }}
                > - </div>
              </div>
              <p className="label">Draw Odds</p>
            </div>
            <div className="stat" style={{ overflow: 'hidden' }}>
              <Locktext LockIcon={LockIcon} text={huntData?.success ? huntData.success.toFixed(0) + '%' : '0' + '%'} showText={huntPlannerFilterOptions?.huntResearch}></Locktext>
              <div className="progress">
                <div
                  className="progress-bar green"
                  style={{ width: `${huntPlannerFilterOptions?.huntResearch ? (huntData.success + '%') : '0%'}` }}></div>
              </div>
              <p className="label" style={{ width: '110px', textAlign: 'right' }}>Harvest Success</p>
            </div>
          </div>
        </div>
      }

      {loadItemDetails && (
        <SideDrawerMenu
          width={'46.86vw'}
          onClick={(e) => {
            e.stopPropagation(); // Prevent event from bubbling up to unit-card
          }}
        >
          {selectedTab == "Units" ?
            <UnitDetails
              unitData={huntData}
              selectedTab={selectedTab}
              selectedFilterOptions={selectedFilterOptions}
              unitDetailsResponse={unitDetailsResponse}
              renderLayerUnit={renderLayerUnit}
              closeTheCard={closeUnit}
              location={'menu'}
            />
            :
            <HuntDetails
              unitData={huntData}
              selectedTab={selectedTab}
              selectedFilterOptions={selectedFilterOptions}
              unitNameRelatedData={huntData}
              unitDetails={huntData}
              from={"hunt"}
              location={'menu'}
              renderLayerUnit={renderLayerUnit}
              closeTheCard={closeUnit}
            />}

        </SideDrawerMenu>
      )}

    </>
  );
};

const mapStateToProps = state => ({
  huntplannerStatesData: state.huntplannerStatesData,
  auth: state.auth,
  huntplannerMapReference: typeof state.huntplannerMapReference === 'function' ? state.huntplannerMapReference() : null,
  huntPlannerFilterOptions: state.huntPlannerFilterOptions,
  huntPlannerLoader: state.huntPlannerLoader,
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
})

const mapDispatchToProps = dispatch => ({
  stopLoading: () => dispatch(stopLoading()),
  startLoading: () => dispatch(startLoading()),
  huntPlannerActiveOtions: (payload) => dispatch(huntPlannerActiveOtions(payload)),
  fetchGetHuntUnitList: (payload) => dispatch(fetchGetHuntUnitList(payload)),
  fetchGetHuntList: (payload) => dispatch(fetchGetHuntList(payload)),
  fetchGetFilterValues: (payload) => dispatch(fetchGetFilterValues(payload)),
  fetchGetUnitDetails: (payload) => dispatch(fetchGetUnitDetails(payload)),
  huntPlannerRightMenuBarOpen: (payload) => dispatch(huntPlannerRightMenuBarOpen(payload)),
  huntPlannerRightMenuBarClose: () => dispatch(huntPlannerRightMenuBarClose())
})

export default connect(mapStateToProps, mapDispatchToProps)(HuntItemsData)

